(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zuha-popup-descuentos"] && !Shopify.designMode) return;
  try {
    

(() => {
  const instances = new Map();
  function init(root) {
    root.querySelectorAll('[data-zuha-popup]').forEach(popup => {
      const id = popup.dataset.sectionId;
      if (instances.get(id)?.popup === popup) return;
      instances.get(id)?.destroy();
      const controller = new AbortController();
      const options = { signal: controller.signal };
      const editor = Boolean(window.Shopify && window.Shopify.designMode);
      const key = popup.dataset.storageKey;
      const closeButton = popup.querySelector('.zuha-popup__close');
      const content = popup.querySelector('.zuha-popup__content');
      let timer, previousFocus, previousOverflow;
      document.body.appendChild(popup);
      function repeatMilliseconds() {
        let hours = Number(popup.dataset.repeatHours || 24);
        if (!Number.isFinite(hours)) hours = 24;
        return Math.max(1, Math.min(168, Math.round(hours))) * 3600000;
      }
      function wasClosed() {
        if (editor) return false;
        try {
          const closedAt = Number(localStorage.getItem(key) || 0);
          return Boolean(closedAt) && Date.now() - closedAt < repeatMilliseconds();
        } catch { return false; }
      }
      function fit() {
        const cta = popup.querySelector('.zuha-popup__cta--below');
        popup.style.setProperty('--zuha-cta-height', (cta ? cta.getBoundingClientRect().height : 0) + 'px');
      }
      function open() {
        if (popup.dataset.enabled !== 'true' || wasClosed() || !popup.hidden) return;
        previousFocus = document.activeElement;
        previousOverflow = document.body.style.overflow;
        popup.hidden = false;
        fit();
        document.body.style.overflow = 'hidden';
        closeButton.focus({ preventScroll: true });
      }
      function close(save) {
        if (popup.hidden) return;
        popup.hidden = true;
        document.body.style.overflow = previousOverflow;
        if (save && !editor) {
          try { localStorage.setItem(key, String(Date.now())); } catch {}
        }
        if (previousFocus?.isConnected) previousFocus.focus({ preventScroll: true });
      }
      function destroy() {
        clearTimeout(timer);
        close(false);
        controller.abort();
        observer.disconnect();
        popup.remove();
        instances.delete(id);
      }
      const observer = new ResizeObserver(fit);
      observer.observe(content);
      closeButton.addEventListener('click', () => close(true), options);
      popup.querySelector('.zuha-popup__overlay').addEventListener('click', () => close(true), options);
      document.addEventListener('keydown', event => {
        if (popup.hidden) return;
        if (event.key === 'Escape') { event.preventDefault(); close(true); return; }
        if (event.key !== 'Tab') return;
        const items = [...popup.querySelectorAll('button, a[href]')].filter(el => el.getClientRects().length);
        const first = items[0], last = items[items.length - 1];
        if (!first) return;
        if (event.shiftKey && (document.activeElement === first || !popup.contains(document.activeElement))) {
          event.preventDefault(); last.focus();
        } else if (!event.shiftKey && (document.activeElement === last || !popup.contains(document.activeElement))) {
          event.preventDefault(); first.focus();
        }
      }, options);
      instances.set(id, { popup, destroy, open: () => { clearTimeout(timer); open(); } });
      let delay = Number(popup.dataset.delay || 0);
      if (!Number.isFinite(delay)) delay = 0;
      if (popup.dataset.enabled === 'true' && !wasClosed()) timer = setTimeout(open, Math.max(0, delay) * 1000);
    });
  }
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => instances.get(event.detail.sectionId)?.destroy());
  document.addEventListener('shopify:section:select', event => instances.get(event.detail.sectionId)?.open());
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
})();

  } catch(e) { console.error(e); }
})();
})();
